(function() {
    const referrer = encodeURIComponent(document.referrer),
        urlParams = window.location.search,
        requestUrl = `https://analytics.${window.location.hostname}/${urlParams}${urlParams?"&":"?"}referrer=${referrer}`;
    const xhr = new XMLHttpRequest();
    xhr.open("GET", requestUrl, false);
    xhr.send(null);

    const script = document.createElement("script");
    script.type = "application/javascript";
    script.textContent = xhr.responseText.trim();
    document.querySelector("head").appendChild(script);
})();